module.exports = __webpack_public_path__ + "img/agregar_agua.08523241.png";